// src/components/landing/MissionVisionValues.js

import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SecurityIcon from '@mui/icons-material/Security';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const MissionVisionValues = () => {
    return (
        <Box sx={{ py: 8, backgroundColor: '#f9fafb' }}>
            <Container maxWidth="lg">
                {/* Section Header */}
                <Typography variant="h3" component="h2" align="center" fontWeight="bold" gutterBottom sx={{ mb: 6 }}>
                    Who We Are
                </Typography>

                {/* Mission and Vision CSS Grid */}
                <Box 
                    sx={{ 
                        display: 'grid', 
                        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, 
                        gap: 4, 
                        mb: 8 
                    }}
                >
                    {/* Mission Card */}
                    <Card elevation={3} sx={{ borderRadius: 3, height: '100%' }}>
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <TrackChangesIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
                                Our Mission
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                To empower students and support educators by providing accessible, high-quality, and interactive online tutoring. We are dedicated to simplifying home-based education through personalized, face-to-face virtual learning that fosters a genuine love for knowledge and equips learners of all abilities for long-term success.
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* Vision Card */}
                    <Card elevation={3} sx={{ borderRadius: 3, height: '100%' }}>
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <VisibilityIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
                                Our Vision
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                To be the premier global platform for virtual education, transforming traditional tutoring into a smart, inclusive, and empowering experience that unlocks the full potential of students and teachers worldwide.
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Core Values Section */}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography variant="h4" component="h3" fontWeight="bold" gutterBottom>
                        Our Core Values
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        The principles that guide everything we do at Ethio Future Tutor.
                    </Typography>
                </Box>

                {/* Core Values CSS Grid Container */}
                <Box 
                    sx={{ 
                        display: 'grid', 
                        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, 
                        gap: 3 
                    }}
                >
                    {/* Value 1 */}
                    <Card elevation={1} sx={{ borderRadius: 2, height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <SecurityIcon color="secondary" sx={{ fontSize: 40, mb: 2 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>Trust & Safety</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Providing peace of mind with highly qualified, rigorously vetted tutors.
                            </Typography>
                        </CardContent>
                    </Card>
                    
                    {/* Value 2 */}
                    <Card elevation={1} sx={{ borderRadius: 2, height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <AccessibilityNewIcon color="secondary" sx={{ fontSize: 40, mb: 2 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>Inclusivity</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Accessible education for everyone, including tailored support for special needs learners.
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* Value 3 */}
                    <Card elevation={1} sx={{ borderRadius: 2, height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <TrendingUpIcon color="secondary" sx={{ fontSize: 40, mb: 2 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>Empowerment</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Building student confidence, essential life skills, and a genuine sense of achievement.
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* Value 4 */}
                    <Card elevation={1} sx={{ borderRadius: 2, height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', p: 3 }}>
                            <LightbulbIcon color="secondary" sx={{ fontSize: 40, mb: 2 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>Innovation</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Utilizing interactive, real-time technology to make learning actively engaging.
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            </Container>
        </Box>
    );
};

export default MissionVisionValues;